import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';
import { parseGroupTripJson } from './groupTripJson';

/** 個人後續行程來源；一般行程沒有來源時後端回 95165，由呼叫端視為「無來源」。 */
export const journeyContinuationApi = {
  getContinuationSource: (journeyId) => travelClient.get(
    travelEndpoints.journeyContinuationSource(journeyId),
    { transformResponse: [parseGroupTripJson] },
  ),
};
